const elementDescriptions = {
  shellRoot: "המעטפת הראשית של הדשבורד. שולטת ברקע הכללי ובגבולות החיצוניים.",
  sidebarRoot: "סרגל הניווט הצדדי. מכיל קישורים לכל העמודים ופרטי מותג.",
  sidebarHeader: "אזור הכותרת של סרגל הצד. מכיל לוגו ושם חברה.",
  sidebarLogo: "סמל הלוגו של החברה בכותרת סרגל הצד.",
  sidebarName: "שם החברה/מותג שמוצג בכותרת סרגל הצד. ניתן לעריכת טקסט.",
  sidebarNav: "אזור הניווט הראשי עם קישורים לכל הטאבים.",
  sidebarNavLink: "קישור ניווט בודד בסרגל הצד. שולט ברקע, צבע וגופן.",
  sidebarNavLabel: "תווית הטקסט של קישור ניווט. ניתן לשנות שם ועיצוב.",
  sidebarFooter: "אזור התחתית של סרגל הצד.",
  sidebarTagline: "החתימה הדיגיטלית בתחתית סרגל הצד. ניתן לעריכת טקסט.",
  topbarRoot: "סרגל הכלים העליון עם ווידג׳טים, חיפוש ופעולות מהירות.",
  contentMain: "אזור התוכן הראשי של הדשבורד.",
  pageHeader: "כותרת העמוד עם כותרת ותיאור.",
  pageHeaderTitle: "כותרת העמוד הראשית. ניתן לעריכת טקסט וגופן.",
  pageHeaderDescription: "תיאור העמוד מתחת לכותרת. ניתן לעריכת טקסט.",
  cardProject: "כרטיס פרויקט ברשימת השכבות. שולט ברקע וגבולות.",
  cardProjectName: "שם הפרויקט בכרטיס. ניתן לעריכת טקסט וגופן.",
  cardProjectMeta: "פרטי מטא של הפרויקט: שכבה, סטטוס, מקור.",
  badgeHealth: "תג ציון בריאות הפרויקט. שולט בצבעי הרקע והטקסט.",
} as const;
export default elementDescriptions;
